import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useFetch } from '@shell/components/Resource/Detail/FetchLoader/composables';
import Tab from '@shell/components/Tabbed/Tab.vue';
import { useI18n } from '@shell/composables/useI18n';
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import SortableTable from '@shell/components/SortableTable/index.vue';
import { useInterval } from '@shell/composables/useInterval';

export interface Props {
  value: any;
}

export interface Detail {
  label: string;
  values: (string | { component: any; props: any })[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AutoscalerTab',
  props: {
    value: { default: true }
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const i18n = useI18n(store);

const table = ref<any>(null);

const eventHeaders = [
  {
    name:  'type',
    label: i18n.t('tableHeaders.type'),
    value: '_type',
    sort:  '_type',
  },
  {
    name:  'reason',
    label: i18n.t('tableHeaders.reason'),
    value: 'reason',
    sort:  'reason',
  },
  {
    name:          'date',
    label:         i18n.t('tableHeaders.updated'),
    value:         'firstTimestamp',
    sort:          'date:desc',
    formatter:     'LiveDate',
    formatterOpts: { addSuffix: true },
    width:         125
  },
  {
    name:  'message',
    label: i18n.t('tableHeaders.message'),
    value: 'message',
    sort:  'message',
  },
];

const fetch = useFetch(async() => {
  return await props.value.loadAutoscalerEvents();
});

// From the FAQ there appears to be a 20 second target between detecting scaling needs to happen to scaling beginning
// so I don't see a reason to poll quicker than 20 seconds.
// https://github.com/kubernetes/autoscaler/blob/9befb31fd94d73ae0b888bd9536ae085cd9304e1/cluster-autoscaler/FAQ.md#what-are-the-service-level-objectives-for-cluster-autoscaler
useInterval(() => {
  fetch.value.refresh();
}, 20000);

const rows = computed(() => {
  return fetch.value.data || [];
});

onMounted(() => {
  table.value?.changeSort('date', true);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tab, {
    name: "autoscaler",
    label: _unref(i18n).t('autoscaler.tab.title')
  }, {
    default: _withCtx(() => [
      _createVNode(SortableTable, {
        ref_key: "table",
        ref: table,
        headers: eventHeaders,
        namespaced: false,
        "row-actions": false,
        "default-sort-by": "date",
        rows: rows.value
      }, null, 8, ["rows"])
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})